import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitForm(event) {
    const jobDescriptionId = event.target.value
    const roleId = event.target.dataset.roleId

    if (!jobDescriptionId || !roleId) return

    // Use Turbo to submit a PATCH request
    const url = `/job_descriptions/${jobDescriptionId}/link_to_role`
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ role_id: roleId })
    })
    .then(response => {
      if (response.redirected) {
        // Follow the redirect
        window.location.href = response.url
      } else if (response.ok) {
        // If no redirect, go to role path
        window.location.href = `/roles/${roleId}`
      } else {
        console.error('Response status:', response.status)
        alert('Failed to link job description: ' + response.statusText)
      }
    })
    .catch(error => {
      console.error('Error:', error)
      alert('An error occurred while linking the job description: ' + error.message)
    })
  }
}
